import { Box, Stack, Typography } from '@mui/material';
import Image from 'next/image';

import { ButtonWithIcon } from '@/components/buttons/buttonWithIcon';
import { Icon } from '@/components/shared/icon';

import pinkBackgroundSpaceship from '../../../public/statics/images/illustrations/onboarding/pink_background_spaceship.png';

export const WelcomePageWrapper = ({
  children,
  onBack,
}: React.PropsWithChildren<{ onBack?: () => void }>) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        padding: 'min(100px,4vw)',
      }}
    >
      <Stack
        direction='row'
        sx={{
          width: '100%',
          height: '100%',
          justifyContent: 'space-between',
        }}
      >
        <Box className='flex items-center'>
          <Image
            alt='bring-your-own-cloud'
            height={760}
            width={760}
            src={pinkBackgroundSpaceship}
            style={{ width: '40vw', height: '40vw' }}
          />
        </Box>
        <Stack
          className='bg-[white] rounded-[16px] overflow-y-auto'
          sx={{
            padding: 'min(100px,4vw)',
            minWidth: '50%',
            gap: '40px',
          }}
        >
          {onBack && (
            <ButtonWithIcon
              onClick={onBack}
              text='Back'
              icon='material-symbols-chevron-left-rounded'
              iconPosition='left'
            />
          )}
          <Stack
            sx={{
              flexGrow: 1,
              justifyContent: 'center',
            }}
          >
            {children}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

export const WelcomePageListItem = ({ text }: { text: string }) => {
  return (
    <Stack
      direction='row'
      sx={{
        gap: '12px',
        alignItems: 'center',
      }}
    >
      <Icon iconClass='material-symbols-check' />
      <Typography variant='subtitle1'>{text}</Typography>
    </Stack>
  );
};
